export const GisCodes = [
  {code: 'SIG', wording: 'Vin sans indication géographique (VSIG)'},
  {code: 'AOC', wording: 'Appellation d\'origine contrôlée (AOC)'},
  {code: 'AOP', wording: 'Appellation d\'origine protégée (AOP)'},
  {code: 'IGP', wording: 'Indication géographique protégée (IGP)'}

];
